import * as Constants from '../actions/constants';
import { getTbuTarget } from "../apis";

export const udcGetRequest = () => ({
    type: Constants.GET_UDC_REQUEST
})

export const udcGetSuccess = payload => ({
    type: Constants.GET_UDC_SUCCESS,
    payload
})

export const udcGetFailure = error => ({
    type: Constants.GET_UDC_FAILURE,
    error
})

export const getUDC = () => dispatch =>{
    getTbuTarget().then(response => {
        dispatch({
            type: Constants.GET_UDC_SUCCESS,
            payload: response
        })
    }).catch(err => console.error(err))
}